__webpack_require__.p = "/assets/turbo/7ff7f7ee/quellede/_next/";